import appColors from "./colors";
const black = "#000000";
const transparent = "transparent";
const palette = {
    black,
    transparent,
    ...appColors,
};
export default palette;
